<template>
  <v-dialog v-model="value" max-width="650" scrollable @click:outside="$emit('input',false)">
    <v-card min-height="350">
      <v-card-title>
        <div>公告详情</div>
        <v-spacer />
        <v-btn icon @click="$emit('input',false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="2">发布时间:</v-col>
          <v-col cols="10">{{Utility.fmtDt(formData.ct)}}</v-col>
          <v-col cols="2">标题:</v-col>
          <v-col cols="10">{{formData.title}}</v-col>
          <v-col cols="12">内容:</v-col>
          <v-col cols="12">{{formData.content}}</v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['value', 'formData']
}
</script>